/*
 * Functions for Global Alerts via Bootstrap Component Toasts
 * Template: templates/v5/default/body.html contains {# Global Alerts #} <div> containers
 * Copied and modified from: static_src/js/c2Archive/alerts.js
 */

(function (__module__) {
  'use strict';

  var logger = c2.logging.getLogger(__module__)

  //prevents duplicate messages (having exactly same string content)
  var alreadyAddedMessages = [];

  // Get icon from tags
  function getIconFromTags(tags) {
    switch (tags) {
      case 'error':
        return 'bi bi-exclamation-circle-fill';
      case 'warning':
        return 'bi bi-exclamation-triangle-fill';
      case 'info':
        return 'bi bi-info-circle-fill';
      case 'success':
        return 'bi bi-check-circle-fill';
      default:
        return;
    }
  }

  // Get heading from tags
  function getToastHeading(tags) {
    var validTags = ['error', 'info', 'success', 'warning'];
    if (validTags.indexOf(tags) !== -1) {
      var icon = getIconFromTags(tags) ? '<i class="' + getIconFromTags(tags) + ' me-2"></i>' : '';
      var tagClass = tags == 'error' ? 'danger' : tags;
      return '<strong class="me-auto text-' + tagClass + '">' + icon +
        '<span class="text-capitalize">' + tags + '</span></strong>';
    }
    return;
  }

  // Clear specific alert from alreadyAddedMessages
  function init() {
    document.getElementById('alert-box')?.addEventListener('hidden.bs.toast', () => {
      $('#alert-box').find('div.toast.hide').each(function () {
        var msg = $(this).children('.toast-body').html();
        if (alreadyAddedMessages.indexOf(msg) > -1) {
          alreadyAddedMessages.splice(alreadyAddedMessages.indexOf(msg), 1);
        }
        $(this).remove();
      });
    });
  }

  // Toasts auto-dismiss via Bootstrap's own autohide; callers may override the
  // duration with `dismissMilliseconds`.
  var DEFAULT_DISMISS_MS = 6000;

  // Adds alert from Django messages notification
  function addGlobalAlert(msg, tags, dismissable, dismissMilliseconds) {
    var dismiss = "";
    var $box = $('#alert-box');

    if (dismissable === true) {
      dismiss = '<button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>';
    }

    if (alreadyAddedMessages.indexOf(msg) !== -1) {
      return;
    }
    logger.debug('Alert msg: ' + msg);
    alreadyAddedMessages.push(msg);

    // NB: no `show` class — Bootstrap's Toast.show() handles visibility so the
    // built-in autohide timer actually runs (a bare `.toast.show` div never
    // auto-dismisses).
    var $message = $('<div role="alert" class="toast align-items-center m-3 fade" aria-live="assertive" aria-atomic="true">' +
      '<div class="toast-header">' + getToastHeading(tags) + dismiss + '</div>' +
      '<div class="toast-body">' + msg + '</div></div>');

    // When the toast finishes hiding (autohide, close button, or
    // clearGlobalAlerts) drop it from the de-dupe list and the DOM.
    $message.on('hidden.bs.toast', function () {
      var body = $(this).children('.toast-body').html();
      var i = alreadyAddedMessages.indexOf(body);
      if (i > -1) {
        alreadyAddedMessages.splice(i, 1);
      }
      $(this).remove();
    });

    // Add in reverse-chronological order, then start the Bootstrap toast.
    setTimeout(function () {
      $box.prepend($message);
      bootstrap.Toast.getOrCreateInstance($message[0], {
        autohide: true,
        delay: dismissMilliseconds || DEFAULT_DISMISS_MS,
      }).show();
    }, 500);
  }

  // Clear all alerts — let each toast fade out via Bootstrap, then self-remove
  // through the hidden.bs.toast handler above.
  function clearGlobalAlerts() {
    $('#alert-box').find('div.toast').each(function () {
      var toast = bootstrap.Toast.getInstance(this);
      if (toast) {
        toast.hide();
      } else {
        $(this).remove();
      }
    });
    alreadyAddedMessages = [];
  }


  c2[__module__] = {
    addGlobalAlert: addGlobalAlert,
    clearGlobalAlerts: clearGlobalAlerts,
    init: init,
  };
})('alerts');
